"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.composeSend = void 0;
const auth_1 = require("./auth");
const compose_url_1 = require("./compose-url");
const redirect_1 = require("./redirect");
const require_status_1 = require("./require-status");
const retry_1 = require("./retry");
const reject_http_error_1 = require("./reject-http-error");
const cancellation_tracker_1 = require("./cancellation-tracker");
const abort_timed_out_fetch_1 = require("./abort-timed-out-fetch");
/**
 * This function is composing Send stack based on Endpoint model's properties.
 * @param baseSend Manadatory send stack for low-level logic.
 * @param endpoint The Endpoint model.
 * @param endpointsSet  The Endpoint set.
 * @param managerContext  The endpoint manager context.
 */
const composeSend = (baseSend, endpoint, endpointsSet, managerContext) => {
    const { cancellationMap } = managerContext;
    let _send = baseSend;
    // Abort fetch if request times out
    _send = (0, abort_timed_out_fetch_1.abortTimedOutFetch)(_send, managerContext.cancellationMap, endpoint.abortOnTimeout);
    if (endpointsSet.authResource) {
        // Authorize the request
        _send = (0, auth_1.authorize)(_send, endpointsSet.authResource);
    }
    // compose final URL from base URL and request's url
    _send = (0, compose_url_1.composeUrl)(_send, endpointsSet, managerContext);
    // Add redirect logic if endpoint has Redirect policy
    _send = (0, redirect_1.redirect)(_send, endpoint, endpointsSet);
    if (endpoint.rejectHttpError) {
        _send = (0, reject_http_error_1.rejectHttpError)(_send);
    }
    if (endpoint.allowedResponses) {
        // Resolve request only for response codes in allowedResponses. Reject otherwise.
        _send = (0, require_status_1.requireStatus)(_send, ...endpoint.allowedResponses);
    }
    if (endpoint.retryPolicy) {
        // Add retry logic if endpoint has Retry policy
        _send = (0, retry_1.retryWithPolicy)(_send, endpoint.retryPolicy, managerContext);
    }
    // add cancellation management
    _send = (0, cancellation_tracker_1.cancellationTracker)(_send, cancellationMap);
    return _send;
};
exports.composeSend = composeSend;
